import React from "react"
import SelectDropdown from "../SelectDropdown"
import FormSection from "../FormSection"
import TextAreaInput from "../TextAreaInput"

export default function Goals({ uniqueQuestion }) {
  const yesNo = [
    { value: "", label: "Please Select" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ]

  const yesUndecidedNo = [
    { value: "", label: "Please Select" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "undecided", label: "Undecided" },
  ]

  return (
    <FormSection title="Your Goals" className="bg-gray-100">
      <div className="grid grid-cols-2 gap-y-6">
        <div className="flex flex-col space-y-4 mr-32">
          <div className=" space-y-6">
            <SelectDropdown
              label={uniqueQuestion}
              name="renovation_design_goals_exist"
              as="select"
              options={yesNo}
              className="flex flex-col mr-32"
            />
            <TextAreaInput
              label={
                <>
                  <p>
                    If <span className="text-tertiary">yes</span>
                  </p>
                  <p>Please list below</p>
                </>
              }
              name="renovation_design_goals"
              className="flex flex-col col-span-2"
            />
          </div>
        </div>
        <div className="flex flex-col space-y-4 mr-32">
          <div className=" space-y-6">
            <SelectDropdown
              label="Is material preference and/or is sustainability a factor?"
              name="material_preference_or_sustainability_factor"
              as="select"
              options={yesUndecidedNo}
              className="flex flex-col mr-32"
            />
            <TextAreaInput
              label={
                <>
                  <p>
                    If <span className="text-tertiary">yes</span>
                  </p>
                  <p>Please list below</p>
                </>
              }
              name="material_preference_or_sustainability"
              className="flex flex-col col-span-2"
            />
          </div>
        </div>
      </div>
    </FormSection>
  )
}
